import { LoaderCircleIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

export interface LoadingSpinnerProps {
  classNames?: {
    wrapper?: string
  }
  iconSize?: number
}

export const LoadingSpinner = ({ classNames, iconSize }: LoadingSpinnerProps) => {
  return (
    <div className={cn('text-primary', classNames?.wrapper)}>
      <LoaderCircleIcon size={iconSize ? iconSize : 24} className={cn('animate-spin')} />
    </div>
  )
}
